export const idiomas = {
  "en-GB": {
    menu: {
      inicio: "HOME",
      promociones: "PROMOTIONS",
      tu_carro: "Your cart",
    },
    articulo: {
      stock: "Stock",
      no_stock: "No stock",
    },
    acciones: {
      anyadir_al_carro: "ADD TO CART",
      ver_detalle: "SHOW DETAIL",
      confirmar: "CONFIRM",
    },
    envio: {
      direccion_envio: "Billing address",
      nombre: "First name",
      error_nombre: "Valid first name is required",
      apellidos: "Last name",
      apellidos_2: "Second lastname",
      error_apellidos: "Valid last name is required",
      telefono: "Phone",
      opcional: "Optional",
      error_email: "Please enter a valid email address",
      direccion: "Address",
      error_direccion: "Please enter your billing address",
      direccion_2: "Address 2",
      pais: "Country",
      error_pais: "Please select a valid country",
      poblacion: "State",
      error_poblacion: "Please provide a valid state.",
      provincia: "County",
      error_poblacion: "Please select a valid county",
      codigo_postal: "Zip Code",
      error_codigo_postal: "Zip code required",
      mensaje_direccion_facturacion_misma:
        "Shipping address is the same as my billing address",
        opcion_envio: "Shipping options",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
    },
    
    resguardo: {
      gracias: "Thanks for your order",
      numero_pedido: "The number of your order is ",
      confirmacion: "Confirmation"
    }
  },
  "es-ES": {
    menu: {
      inicio: "INICIO",
      promociones: "PROMOCIONES",
      tu_carro: "Carro",
    },
    articulo: {
      stock: "Stock",
      no_stock: "No stock",
    },
    acciones: {
      anyadir_al_carro: "AÑADIR AL CARRO",
      ver_detalle: "VER DETALLE",
      confirmar: "CONFIRM",
    },
    envio: {
      direccion_envio: "Dirección de facturación",
      nombre: "Nombre",
      error_nombre: "El nombre es obligatorio",
      apellidos: "Primer apellido",
      apellidos_2: "Segundo apellido",
      error_apellidos: "El apellido es obligatorio",
      telefono: "Teléfono",
      opcional: "Opcional",
      error_email: "El formato del email no es válido",
      direccion: "Dirección",
      error_direccion: "La dirección es necesaria",
      direccion_2: "Extensión dirección",
      pais: "País",
      error_pais: "Por favor, elija un país válido",
      poblacion: "Población",
      error_poblacion: "Por favor, indique una población válida",
      provincia: "Provincia",
      error_poblacion: "Por favor, indique una provincia válida",
      codigo_postal: "Código postal",
      error_codigo_postal: "El código postal es obligatorio",
      mensaje_direccion_facturacion_misma:
        "La dirección de facturación es la misma que la del envío",
        opcion_envio: "Opción de envío",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
    },
    resguardo: {
      gracias: "Gracias por su pedido",
      numero_pedido: "El nº de su pedido es ",
      confirmacion: "Confirmación"
    }
  },
  "es-CL": {
    menu: {
      inicio: "INICIO",
      promociones: "PROMOCIONES",
      tu_carro: "Carro",
    },
    articulo: {
      stock: "Stock",
      no_stock: "No stock",
    },
    acciones: {
      anyadir_al_carro: "AÑADIR AL CARRO",
      ver_detalle: "VER DETALLE",
      confirmar: "CONFIRMAR",
    },
    envio: {
      direccion_envio: "Dirección de facturación",
      nombre: "Nombre",
      error_nombre: "El nombre es obligatorio",
      apellidos: "Apellidos",
      apellidos_2: "Segundo apellido",
      error_apellidos: "El apellido es obligatorio",
      telefono: "Teléfono",
      opcional: "Opcional",
      error_email: "El formato del email no es válido",
      direccion: "Dirección",
      error_direccion: "La dirección es necesaria",
      direccion_2: "Extensión dirección",
      pais: "País",
      error_pais: "Por favor, elija un país válido",
      poblacion: "Población",
      error_poblacion: "Por favor, indique una población válida",
      provincia: "Provincia",
      error_poblacion: "Por favor, indique una provincia válida",
      codigo_postal: "Código postal",
      error_codigo_postal: "El código postal es obligatorio",
      mensaje_direccion_facturacion_misma:
        "La dirección de facturación es la misma que la del envío",
        opcion_envio: "Opción de envío",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
    },
    
    resguardo: {
      gracias: "Gracias por su pedido",
      numero_pedido: "El nº de su pedido es ",
      confirmacion: "Confirmation"
    }
  },
  "fr-FR": {
    menu: {
      inicio: "MAISON",
      promociones: "PROMOTIONS",
      tu_carro: "PANIER",
      confirmar: "CONFIRM",
    },
    articulo: {
      stock: "Stock",
      no_stock: "Sans stock",
    },
    acciones: {
      anyadir_al_carro: "AJOUTER AU PANIER",
      ver_detalle: "MONTRER LES DÉTAILS",
    },
    envio: {
      direccion_envio: "Shipping address",
      nombre: "First name",
      error_nombre: "Valid first name is required",
      apellidos: "Last name",
      apellidos_2: "Second lastname",
      error_apellidos: "Valid last name is required",
      telefono: "Phone",
      opcional: "Optional",
      error_email: "Please enter a valid email address",
      direccion: "Address",
      error_direccion: "Please enter your shipping address",
      direccion_2: "Address 2",
      pais: "Country",
      error_pais: "Please select a valid country",
      poblacion: "State",
      error_poblacion: "Please provide a valid state.",
      provincia: "County",
      error_poblacion: "Please select a valid county",
      codigo_postal: "Zip Code",
      error_codigo_postal: "Zip code required",
      mensaje_direccion_facturacion_misma:
        "Shipping address is the same as my billing address",
        opcion_envio: "Shipping options",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
    },
    resguardo: {
      gracias: "Gracias por su pedido",
      numero_pedido: "El nº de su pedido es ",
      confirmacion: "Confirmation"
    }
  },
  "pt-PT": {
    menu: {
      inicio: "INÍCIO",
      promociones: "PROMOÇÕES",
      tu_carro: "CARRINHO",
    },
    articulo: {
      stock: "Estoque",
      no_stock: "Sem estoque",
    },
    acciones: {
      anyadir_al_carro: "ADICIONAR AO CARRINHO",
      ver_detalle: "MOSTRAR DETALHE",
      confirmar: "CONFIRM",
    },
    envio: {
      direccion_envio: "Endereço de Cobrança",
      nombre: "Nombre",
      error_nombre: "El nombre es obligatorio",
      apellidos: "Apellidos",
      apellidos_2: "Segundo apellido",
      error_apellidos: "El apellido es obligatorio",
      telefono: "Teléfono",
      opcional: "Opcional",
      error_email: "El formato del email no es válido",
      direccion: "Dirección",
      error_direccion: "La dirección es necesaria",
      direccion_2: "Extensión dirección",
      pais: "País",
      error_pais: "Por favor, elija un país válido",
      poblacion: "Población",
      error_poblacion: "Por favor, indique una población válida",
      provincia: "Provincia",
      error_poblacion: "Por favor, indique una provincia válida",
      codigo_postal: "Código postal",
      error_codigo_postal: "El código postal es obligatorio",
      mensaje_direccion_facturacion_misma:
        "La dirección de facturación es la misma que la del envío",
        opcion_envio: "Opción de envío",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
    },
    resguardo: {
      gracias: "Gracias por su pedido",
      numero_pedido: "El nº de su pedido es ",
      confirmacion: "Confirmation"
    }
  },
  "pt": {
    menu: {
      inicio: "INÍCIO",
      promociones: "PROMOÇÕES",
      tu_carro: "CARRINHO",
    },
    articulo: {
      stock: "Estoque",
      no_stock: "Sem estoque",
    },
    acciones: {
      anyadir_al_carro: "ADICIONAR AO CARRINHO",
      ver_detalle: "MOSTRAR DETALHE",
      confirmar: "CONFIRMAR",
    },
    envio: {
      direccion_envio: "Dados de quem retira",
      nombre: "Nome",
      error_nombre: "El nombre es obligatorio",
      apellidos: "Sobrenome",
      apellidos_2: "Sobrenome 2",
      error_apellidos: "El apellido es obligatorio",
      telefono: "Telefone",
      opcional: "Opcional",
      error_email: "El formato del email no es válido",
      direccion: "Endereço",
      error_direccion: "La dirección es necesaria",
      direccion_2: "Complemento endereço",
      pais: "País",
      error_pais: "Por favor, elija un país válido",
      poblacion: "Estado",
      error_poblacion: "Por favor, indique una población válida",
      provincia: "Estado",
      error_poblacion: "Por favor, indique una provincia válida",
      codigo_postal: "CEP",
      error_codigo_postal: "El código postal es obligatorio",
      mensaje_direccion_facturacion_misma:
        "La dirección de facturación es la misma que la del envío",
        opcion_envio: "Opción de envío",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
        
    },
    resguardo: {
      gracias: "Gracias por su pedido",
      numero_pedido: "El nº de su pedido es ",
      confirmacion: "Confirmacion"
    }
  },
  "it-IT": {
    menu: {
      inicio: "PRINCIPALE",
      promociones: "PROMOZIONI",
      tu_carro: "CARRELLO",
    },
    articulo: {
      stock: "Stock",
      no_stock: "Senza stock",
    },
    acciones: {
      anyadir_al_carro: "AGGIUNGI AL CARRELLO",
      ver_detalle: "MOSTRA I DETTAGLI",
      confirmar: "CONFIRM",
    },
    envio: {
      direccion_envio: "Shipping address",
      nombre: "Nombre",
      error_nombre: "El nombre es obligatorio",
      apellidos: "Apellido",
      apellidos_2: "Segundo apellido",
      error_apellidos: "El apellido es obligatorio",
      telefono: "Teléfono",
      opcional: "Opcional",
      error_email: "El formato del email no es válido",
      direccion: "Dirección",
      error_direccion: "La dirección es necesaria",
      direccion_2: "Extensión dirección",
      pais: "País",
      error_pais: "Por favor, elija un país válido",
      poblacion: "Población",
      error_poblacion: "Por favor, indique una población válida",
      provincia: "Provincia",
      error_poblacion: "Por favor, indique una provincia válida",
      codigo_postal: "Código postal",
      error_codigo_postal: "El código postal es obligatorio",
      mensaje_direccion_facturacion_misma:
        "La dirección de facturación es la misma que la del envío",
        opcion_envio: "Opción de envío",
        opcion_envio_domicilio: "Envío a domicilio",
        opcion_envio_recogida: "Recogida en centro",
    },
    resguardo: {
      gracias: "Gracias por su pedido",
      numero_pedido: "El nº de su pedido es ",
      confirmacion: "Confirmation"
    }
  },
};
